module.exports = __webpack_public_path__ + "img/service-card-1.10522fde.png";